module.exports = __webpack_public_path__ + "static/media/step2.7561bdef.webp";